import React from "react";
import { Stack, Button } from "react-bootstrap";
import { useCartContext } from "../context/CartContext";
import storeItems from "../data/StoreData.json";
import FormatCurrency from "./FormatCurrency";
const CartItem = ({ id, quantity ,imgUrl}) => {
  const { removeFromCart } = useCartContext();
  const item = storeItems.find((i) => i.id === id);
  if (item == null) return null;
  return (
    <Stack direction="horizontal" gap={2} className="d-flex cartitem  align-items-center">
      <img
        src={item.imgUrl}
        alt="cart-img"
      />
      <div className="me-auto ">
        <div className="">
          {item.name}{" "}
          {quantity > 1 && (
            <span className="text-muted price">
              x{quantity}
            </span>
          )}
        </div>
        <div className="text-muted price">
          {FormatCurrency(item.price)}
        </div>
      </div>
      <div className="price">{FormatCurrency(item.price * quantity)}</div>
      <Button
        variant="outline-danger"
        size="sm"
        onClick={() => removeFromCart(item.id)}
      >
        &times;
      </Button>
    </Stack>
  );
};

export default CartItem;